import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="M.25 1.66c.1.13 5.74 7.33 5.74 7.33V15c0 .55.45 1 1.01 1h2.01c.55 0 1.01-.45 1.01-1V8.98s5.49-7.02 5.75-7.34S16 1 16 1c0-.55-.45-1-1.01-1H1.01C.4 0 0 .48 0 1c0 .2.06.44.25.66" />
, 'ActionFilterFilledx');
